import { useContext } from "react";
import { QAContext, QAContextType } from "./QAContext";

export function useQAContext(): QAContextType {
	const context = useContext(QAContext);
	if (!context) {
		throw new Error("useQAContext must be used within a QAProvider");
	}
	return context;
}
